module.exports = __webpack_public_path__ + "static/media/add_circle.b929d78f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Workspace/Calculation/add_circle.svg
// module id = 1440
// module chunks = 2